import {
    CORE_LOAD_MASTER_DATA_REQUEST,
    CORE_LOAD_MASTER_DATA_SUCCESS,
    CORE_LOAD_MASTER_DATA_FAILURE,
} from '../masterDataTypes'
import { REQUEST_STATE } from '../types'

const requestState = REQUEST_STATE

export default {
    masterData: (state = requestState, action) => {
        switch (action.type) {
            case CORE_LOAD_MASTER_DATA_REQUEST:
                return state
            case CORE_LOAD_MASTER_DATA_SUCCESS:
                if (action.payload) {
                    console.log("action.payload", action.payload)
                    const { result, data } = action.payload
                    if (result && data) {
                        return data
                    } else return {}
                } else {
                    return {}
                }
            case CORE_LOAD_MASTER_DATA_FAILURE:
                return {}
            default:
                return state
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/redux/reducers/masterData.js